import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaGlobe, FaClock } from 'react-icons/fa';

const details = [
  {
    icon: FaMapMarkerAlt,
    label: 'Our Location',
    value: 'Ramdabazar, Alinagar, Beanibazar, Sylhet',
  },
  {
    icon: FaPhone,
    label: 'Phone Number',
    value: '+8801623607784',
    href: 'tel:+8801623607784',
  },
  {
    icon: FaEnvelope,
    label: 'Email Address',
    value: 'actechinstitute2024@gmail.com',
    href: 'mailto:actechinstitute2024@gmail.com',
  },
  {
    icon: FaGlobe,
    label: 'Website',
    value: 'www.actech.institute',
    href: 'https://www.actech.institute',
    external: true,
  },
  {
    icon: FaClock,
    label: 'Working Hours',
    value: 'Sun - Thu: 9:00 AM - 5:00 PM',
  },
];

const Contact = () => {
  return (
    <div className="container-page">
      <div className="max-w-2xl">
        <span className="eyebrow">Get in touch</span>
        <h2 className="section-title">Talk to us about your next course</h2>
        <p className="section-lead">
          Questions about a programme, the schedule or the fee? Call, email or drop by the
          institute &mdash; we are happy to walk you through the options.
        </p>
      </div>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {details.map(({ icon: Icon, label, value, href, external }) => (
          <div key={label} className="card p-6">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-surface-line bg-surface-base text-brand-400">
              <Icon className="h-4 w-4" />
            </span>
            <p className="mt-5 text-xs font-medium uppercase tracking-[0.14em] text-ink-faint">
              {label}
            </p>
            {href ? (
              <a
                href={href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="mt-2 block break-words text-sm text-ink transition-colors hover:text-brand-400"
              >
                {value}
              </a>
            ) : (
              <p className="mt-2 break-words text-sm text-ink">{value}</p>
            )}
          </div>
        ))}

        {/* Call to action fills the sixth cell of the grid */}
        <div className="card border-brand-500/40 bg-brand-600/10 p-6">
          <p className="text-sm font-semibold text-ink">Ready to enrol?</p>
          <p className="mt-2 text-sm leading-relaxed text-ink-muted">
            Give us a call and we will get you booked onto the next intake.
          </p>
          <a href="tel:+8801623607784" className="btn-primary mt-5 w-full">
            <FaPhone className="h-3 w-3" />
            Call the institute
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
